/* Tiroir panier Moonbundle (3 novembre 2026).
   1. « Vous aimerez aussi » en cartes empilées, sans flèches (nc-cart-drawer.css). On passe à la pièce suivante
      en glissant au doigt ou au trackpad : la carte sort du côté du geste, la suivante arrive.
   2. À la fermeture du tiroir, le voile du thème (body-overlay) restait actif et invisible :
      il fallait recliquer dans le vide pour retrouver la page. On le ferme avec le tiroir. */
(function () {
  var CUR = '#moonbundle-cart-drawer .moonbundle-cart-upsell-product-current';
  var busy = false;
  var nav = function (dir) {
    var b = document.querySelector('#moonbundle-cart-drawer .moonbundle-cart-upsell-nav-' + dir);
    if (!b || busy) return;
    busy = true;
    var cur = document.querySelector(CUR);
    if (cur) cur.classList.add(dir === 'next' ? 'nc-out-l' : 'nc-out-r');
    // La carte sort, Moonbundle change la pièce, la nouvelle carte entre
    setTimeout(function () {
      b.click();
      setTimeout(function () {
        document.querySelectorAll('#moonbundle-cart-drawer .moonbundle-cart-upsell-product').forEach(function (el) {
          el.classList.remove('nc-out-l', 'nc-out-r', 'nc-in-l', 'nc-in-r', 'nc-nudge');
        });
        var n = document.querySelector(CUR);
        if (n) {
          void n.offsetWidth;
          n.classList.add(dir === 'next' ? 'nc-in-r' : 'nc-in-l');
        }
        busy = false;
      }, 40);
    }, 190);
  };
  // Au premier tiroir de la visite, la carte esquisse un glissé pour montrer qu'on peut la faire passer
  var nudge = function () {
    try { if (sessionStorage.getItem('nc-upsell-nudge')) return; } catch (e) {}
    setTimeout(function () {
      var c = document.querySelector(CUR);
      if (!c) return;
      c.classList.add('nc-nudge');
      setTimeout(function () { c.classList.remove('nc-nudge'); }, 1200);
      try { sessionStorage.setItem('nc-upsell-nudge', '1'); } catch (e) {}
    }, 700);
  };
  var inRail = function (t) {
    return t && t.closest && t.closest('#moonbundle-cart-drawer .moonbundle-cart-upsell-products');
  };

  // Toucher la pièce suivante
  document.addEventListener('click', function (e) {
    var next = e.target.closest && e.target.closest('#moonbundle-cart-drawer .moonbundle-cart-upsell-product-next');
    if (!next) return;
    e.preventDefault();
    e.stopPropagation();
    nav('next');
  }, true);

  // Glisser au doigt
  var x0 = null, y0 = 0;
  document.addEventListener('touchstart', function (e) {
    var on = inRail(e.target);
    x0 = on ? e.touches[0].clientX : null;
    y0 = on ? e.touches[0].clientY : 0;
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
    x0 = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) nav(dx < 0 ? 'next' : 'prev');
  }, { passive: true });

  // Glisser au trackpad (défilement horizontal) : une pièce par geste
  var acc = 0, lock = 0;
  document.addEventListener('wheel', function (e) {
    if (!inRail(e.target) || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    e.preventDefault();
    if (Date.now() < lock) return;
    acc += e.deltaX;
    if (Math.abs(acc) > 30) {
      nav(acc > 0 ? 'next' : 'prev');
      acc = 0;
      lock = Date.now() + 600;
    }
  }, { passive: false });

  // Fermer le voile du thème quand le tiroir se ferme
  var watch = function () {
    var d = document.getElementById('moonbundle-cart-drawer');
    if (!d) return false;
    var was = d.classList.contains('open');
    new MutationObserver(function () {
      var now = d.classList.contains('open');
      if (!was && now) nudge();
      if (was && !now) {
        var ov = document.querySelector('body-element.body-overlay.visible, .body-overlay.visible');
        if (ov) ov.click();
      }
      was = now;
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    return true;
  };
  if (!watch()) {
    var tries = 0, t = setInterval(function () { if (watch() || ++tries > 40) clearInterval(t); }, 250);
  }
})();
